<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button data-test="backButton"></ion-back-button>
        </ion-buttons>
        <ion-title #title (click)="onTitleClick()" data-test="title">Shuttle</ion-title>
        <!-- <ion-buttons slot="end">
            <ion-button [disabled]=vb.disabled color="light" id="more" (click)="onMoreClick($event)" data-test="moreButton">
                <ion-icon name="ellipsis-horizontal"></ion-icon>
            </ion-button>
        </ion-buttons> -->
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header color="secondary">
        Shuttle properties:
    </ion-list-header>

    <ion-list lines="none">
        <form name="form" (ngSubmit)="f.form.valid && onSaveClick(f)" #f="ngForm" novalidate>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Shuttle Name</ion-label>
                <ion-input color="secondary" type="text" name="shuttleName" #shuttleName="ngModel"
                    [ngClass]="{ 'is-invalid': f.submitted && shuttleName.invalid }" required
                    [(ngModel)]="shuttle.shuttleName" id="shuttleName" autofocus="true" data-test="shuttleName">
                </ion-input>
                @if (submitted && shuttleName.invalid) {
                <div data-test="shuttleNameErr">
                    <div class="validationErrorMsg">Shuttle name is required.</div>
                </div>
                }
            </ion-item>

            <ion-item>
                <ion-label class="ion-text-wrap" position="stacked">Description (optional)</ion-label>
                <ion-input id="description" type="text" name="description" [(ngModel)]="shuttle.description"
                    data-test="description">
                </ion-input>
            </ion-item>

            <ion-item id="statusButton" (click)="onStatusClick()">
                <ion-label class="ion-text-wrap" position="stacked">Status (tap to change status)</ion-label>
                <ion-input id="status" type="text" name="status" [(ngModel)]="shuttle.status"
                    data-test="status"></ion-input>
            </ion-item>

            <ion-item-divider class="inset">
                <ion-label class="ion-text-wrap" data-test="passengerCapacityLabel">
                    Passenger Capacity: {{shuttle.passengerCapacity}}
                </ion-label>
            </ion-item-divider>
            <ion-item>
                <ion-range class="insetRange" min="1" max="20" snaps="true" name="passengerCapacity"
                    [(ngModel)]="shuttle.passengerCapacity" color="primary" data-test="passengerCapacity">
                    <ion-label class="ion-text-wrap" color="primary" slot="start">1</ion-label>
                    <ion-label class="ion-text-wrap" color="primary" slot="end">20</ion-label>
                </ion-range>
            </ion-item>

            <!-- @if (isDebugMode) {
  <div>
                <ion-item>
                    <div>
                        <ion-label class="ion-text-wrap" position="stacked">
                            Passenger Capacity - For Protractor Testing Only!</ion-label>
                        <ion-input id="passengerCapacity" type="number" [min]="1" [max]="20" name="debug"
                            [(ngModel)]="shuttle.passengerCapacity"></ion-input>
                    </div>
                </ion-item>
            </div>
} -->
        </form>
    </ion-list>
</ion-content>

<ion-footer>
    <ion-toolbar>
        <ion-button color="primary" expand="full" (click)="onSaveClick(f)" data-test="saveButton">Save</ion-button>
    </ion-toolbar>
</ion-footer>